import { render, staticRenderFns } from "./bbgl-syrj.vue?vue&type=template&id=9eda2d62&scoped=true"
import script from "./bbgl-syrj.vue?vue&type=script&lang=js"
export * from "./bbgl-syrj.vue?vue&type=script&lang=js"
import style0 from "./bbgl-syrj.vue?vue&type=style&index=0&id=9eda2d62&prod&lang=scss"
import style1 from "./bbgl-syrj.vue?vue&type=style&index=1&id=9eda2d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eda2d62",
  null
  
)

export default component.exports